import {Transaction} from "@app/shared";
import { isNullOrUndefined } from "@qntm-code/utils";

export class TxnErrorCodeRequest {
  refId: number;
  txnType: Transaction;
  showStatusInDialog?: boolean = true;       // true by default
  showStatusOnPage?: boolean = false;        // false by default
  emitStatus?: boolean = false;              // false by default

  constructor(txnType?: Transaction, refId?: number, showStatusInDialog?: boolean, showStatusOnPage?: boolean, emitStatus?: boolean) {
    if (!isNullOrUndefined(txnType)) {
      this.txnType = txnType;
    }
    if (!isNullOrUndefined(refId)) {
      this.refId = refId;
    }
    if (!isNullOrUndefined(showStatusInDialog)) {
      this.showStatusInDialog = showStatusInDialog;
    }
    if (!isNullOrUndefined(showStatusOnPage)) {
      this.showStatusOnPage = showStatusOnPage;
    }
    if (!isNullOrUndefined(emitStatus)) {
      this.emitStatus = emitStatus;
    }
  }
}


export class TxnErrorCode {
  description: string;
  roleResponsible: string;
}
